<template>
    <q-card
        v-observe-visibility="v => visible = v"
        :inline="inline"
        :class="['card', 'q-ma-sm', {inEdit: inEdit, draggingOver: draggingOver}]"
        :style="style"
        ref="card"
        v-if="survey">

        <template v-if="visible">
            <q-card-title class="title">
                <div class="row" v-if="survey.isNew">
                    <div class="col-12">
                        <div v-if="! inEdit">{{survey.label}}</div>
                        <q-field
                            v-else
                            label="Tytuł"
                            :error="$v.survey.label.$error"
                            error-label="Pole nie może być puste">
                            <q-input
                                v-model="survey.label"
                                @input="validate"/>
                        </q-field>
                    </div>
                </div>

                <div class="row" v-else label="Tytuł">
                    <div v-if="! inEdit">{{survey.label}}</div>
                    <q-field
                        v-else
                        label="Tytuł"
                        :error="$v.survey.label.$error"
                        error-label="Pole nie może być puste">
                        <q-input
                            v-model="survey.label"
                            @input="validate"/>
                    </q-field>
                </div>
            </q-card-title>

            <q-card-main class="main">
                <!--<q-field label="Czy ankieta jest kwalifikacyjna?">-->
                <!--<q-toggle v-model="survey.qualifying" :readonly="!inEdit"/>-->
                <!--</q-field>-->

                <q-field
                    label="Próg ankiety"
                    v-if="inEdit && survey.qualifying"
                    :error="$v.survey.threshold.$error"
                    error-label="Wartość musi być większa niż 0"
                >
                    <q-input
                        v-model="survey.threshold"
                        type="number"
                        @input="validate"
                        :readonly="!inEdit"/>
                </q-field>

                <category-chooser v-if="inEdit && survey.qualifying"
                                  :category="survey.category"
                                  @selected="e => { setCategory(e); validate() }"/>
                <div v-if="! inEdit && survey.qualifying">
                    <div>Kategoria: {{categoryName}}</div>
                </div>

                <!--<q-field label="Etykieta ankiety" v-if="inEdit && survey.qualifying">-->
                <!--<q-input v-model="survey.fuzzyLabel" type="text" :readonly="!inEdit"/>-->
                <!--</q-field>-->
                <!--<div v-if="! inEdit && survey.qualifying">-->
                <!--<div>Etykieta ankiety: {{survey.fuzzyLabel}}</div>-->
                <!--</div>-->

                <div class="badges q-ma-sm text-right">
                    <group-switcher
                        @change="value => { survey.group = value; validate() }"
                        :value="survey.group"
                        :disabled="! inEdit"/>
                </div>
            </q-card-main>

            <q-card-actions v-if="!inEdit" align="end" class="actions">
                <publish-button :model="survey" what="survey"/>
                <q-btn flat round icon="file_copy" @click.native="cloneAndEdit"/>
                <q-btn flat round icon="edit" @click.native="goToEdit"/>
                <q-btn flat round icon="delete" @click.native="confirmAndDelete"/>
            </q-card-actions>

            <q-card-actions v-if="inEdit" align="end" class="actions"
                            @dragover.native.prevent="dragover"
                            @dragleave.native="dragleave"
                            @dragenter.native="dragenter"
                            @drop.native="dropBackground">
                <q-btn flat round icon="delete" @click.native="confirmAndDelete"/>
            </q-card-actions>
        </template>
    </q-card>
</template>

<script>
    import QCardTitle from 'quasar-framework/src/components/card/QCardTitle'
    import QCardMedia from 'quasar-framework/src/components/card/QCardMedia'
    import QCardMain from 'quasar-framework/src/components/card/QCardMain'
    import QCardActions from 'quasar-framework/src/components/card/QCardActions'
    import QIcon from 'quasar-framework/src/components/icon/QIcon'
    import QBtn from 'quasar-framework/src/components/btn/QBtn'
    import QEditor from 'quasar-framework/src/components/editor/QEditor'
    import QField from 'quasar-framework/src/components/field/QField'
    import GenericViewer from './viewers/GenericViewer'
    import QCard from 'quasar-framework/src/components/card/QCard'
    import QChipsInput from 'quasar-framework/src/components/chips-input/QChipsInput'
    import draggable from 'vuedraggable'
    import QToggle from 'quasar-framework/src/components/toggle/QToggle'
    import QInput from 'quasar-framework/src/components/input/QInput'
    import QRadio from 'quasar-framework/src/components/radio/QRadio'
    import GroupSwitcher from '../GroupSwitcher'
    import PublishButton from './PublishButton'
    import CategoryChooser from '../CategoryChooser'

    import { required, minLength, minValue } from 'vuelidate/lib/validators'

    export default {
        name: 'SurveyComponent',
        components: {
            CategoryChooser,
            PublishButton,
            GroupSwitcher,
            QRadio,
            QInput,
            QToggle,
            QChipsInput,
            QCard,
            GenericViewer,
            QField,
            QEditor,
            QBtn,
            QIcon,
            QCardActions,
            QCardMain,
            QCardMedia,
            QCardTitle,
            draggable,
        },
        props: ['model', 'editable', 'inEdit', 'inline'],
        methods: {
            goToEdit () {
                this.$router.push({
                    name: 'survey-edit',
                    params: {surveyId: this.survey.surveyId},
                })
            },

            cloneAndEdit () {
                const value = this.survey

                const surveyId = this.$uuid()

                const model = {
                    ...this.survey,
                    surveyId: surveyId,
                    label: 'Kopia ' + value.label,
                    questions: value.questions.map(q => {
                        const questionId = this.$uuid()

                        return {
                            ...q,
                            surveyQuestionId: questionId,
                            surveyId: surveyId,
                            answers: (q.answers || []).map(a => {
                                return {
                                    ...a,
                                    surveyAnswerId: this.$uuid(),
                                    surveyQuestionId: questionId,
                                    surveyId: surveyId,
                                }
                            })
                        }
                    }),
                }
                this.$store.dispatch('create', {
                    what: 'survey',
                    item: model,
                    id: model.surveyId
                })
            },

            dragenter () {

            },
            dragover () {
                if (this.inEdit) {
                    this.draggingOver = true
                }
            },
            dragleave () {
                if (this.inEdit) {
                    this.draggingOver = false
                }
            },
            dropTasklet (e) {
                if (this.inEdit) {
                    e.preventDefault()

                    // try {
                    //     var tasklet = JSON.parse(e.dataTransfer.getData('text'))
                    //     if (tasklet.type !== 'survey') {
                    //         this.article.parts.push({
                    //             articlePartId: tasklet.id,
                    //             category: tasklet.type,
                    //             // text: p.text,
                    //             // url: p.url,
                    //         })
                    //     }
                    // } catch (ee) {
                    //     //
                    // }

                    this.draggingOver = false
                }
            },
            dropBackground (/*e*/) {

            },
            save () {

            },
            fetch () {

            },
            removeSurvey (/*part*/) {

            },
            addTextToArticle () {
                this.text = ''
            },
            confirmAndDelete () {
                if (! this.survey.isNew) {
                    this.$q.dialog({
                        title: `Potwierdź usunięcie ankiety`,
                        message: `Czy na pewno usunąć ankietę ${this.survey.text}?`,
                        ok: 'Usuń',
                        cancel: 'Anuluj',
                        position: 'top',
                    }).then(() => {
                        this.$store.dispatch('remove', {
                            what: 'survey',
                            item: this.survey,
                            id: this.survey.surveyId
                        }).then(() => {
                            this.$emit('deleted')
                        })
                    }).catch(() => {

                    })
                } else {
                    this.$emit('deleted')
                }
            },
            setCategory (e) {
                this.$set(this.survey, 'category', e)
                this.$set(this.survey, 'fuzzyLabel', this.categoryName)
            },
            validate () {
                this.$v.$touch()

                this.$emit('valid', ! this.$v.$invalid)
            },
        },
        data () {
            return {
                draggingOver: false,
                isNew: false,
                text: '',
                visible: false,
            }
        },
        mounted () {
            this.validate()
        },
        watch: {
            surveyMethod (current) {
                this.survey.method = current
            },
            survey () {
                this.validate()
            }
        },
        computed: {
            survey () {
                // if (this.$store.state.poles.filter(p => p.id === this.model.id).length > 0) {
                //     return this.$store.state.poles.find(p => p.id === this.model.id)
                // }

                return this.model
            },
            surveyMethod () {
                let types = []
                types = (this.survey.questions || []).reduce((all, q) => {
                    return [...all, q.method]
                }, [])

                types = [...new Set(types)]
                if (types.length === 1) {
                    return types[0]
                } else {
                    return 'mixed'
                }
            },
            style () {
                return ''
            },
            categoryName () {
                if (this.model.category) {
                    const c = this.$store.getters.category.find(c => c.category === this.survey.category)
                    if (c) {
                        return c.label
                    }

                    return ''
                }
            }

        },
        validations () {
            const isQualifying = this.survey.qualifying

            return {
                survey: {
                    label: {
                        required,
                        minLength: minLength(1)
                    },
                    threshold: isQualifying ? {
                        required,
                        minValue: minValue(1)
                    } : {},
                    category: isQualifying ? {
                        required,
                    } : {},
                    group: {
                        required,
                    },
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .card {
        .actions {
            background: gainsboro;
        }

        border-radius: 20px;

        .badges {
            .junior {
                background-color: green;
                color: #fff;
            }

            .senior {
                background-color: orange;
                color: #fff;
            }
        }
    }

    .card:not(.inEdit) {
        width: 350px;
        /*height: 500px;*/
        overflow: hidden;
        position: relative;

        .media {

        }

        .main {

        }
    }

    .card.inEdit {
        width: 350px;
        position: relative;

        .media {

        }

        .main {

        }

        &.draggingOver {
            border: 1px solid red;
        }
    }

    .new-content-area {
        border: 1px dashed gray;
        min-height: 30px;
        line-height: 30px;
        color: gray;
    }

</style>
